<!--Navbar-->
<pmd-navbar class="navbar-expand-xl fixed-top navbar-dark bg-primary py-1" id="navbar">
	<app-navbar-before-login></app-navbar-before-login>
</pmd-navbar>
<!--/.Navbar-->

<!--Main Content Area-->
<main class="pmd-content home-layout pf-before-login-layout" aria-label="Main Content" id="mainContent">
	<router-outlet></router-outlet>
</main>

<div class="">
	<app-secondary-footer></app-secondary-footer>
</div>